
import React from 'react';
import { ArrowRight, Bot } from 'lucide-react';
import { useState } from 'react';
import { WaitlistDialog } from '@/components/WaitlistDialog';

const NavigationButtons = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <nav className="flex flex-col sm:flex-row justify-center gap-4 mb-8 animate-fadeIn">
      <a
        href="https://chromewebstore.google.com/detail/deepseek-ai/inhcgfpbfdjbjogdfjbclgolkmhnooop/reviews?hl=en&gl=US"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white bg-[#0066FF] hover:bg-[#0066FF]/90 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
      >
        Download DeepSeek AI for Free!
        <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" />
      </a>
      <button
        onClick={() => setIsDialogOpen(true)}
        className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#0066FF] text-base font-medium rounded-full text-[#0066FF] bg-white hover:bg-blue-50 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
      >
        Create AI Agents
        <Bot className="ml-2 h-5 w-5" aria-hidden="true" />
      </button>
      
      <WaitlistDialog 
        isOpen={isDialogOpen} 
        onClose={() => setIsDialogOpen(false)} 
      />
    </nav>
  );
};

export default NavigationButtons;
